export const KEYWORD_CACHE_KEYS = {
  LIST: () => ["keywords", "LIST"],
};
